import { useEffect, useState } from 'react'
import { loadStripe, Stripe } from '@stripe/stripe-js'

export const useStripePromise = (isInstore) => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe>>()

  useEffect(() => {
    const stripeKey = process.env.STRIPE_KEY as string
    if (stripeKey) {
      if (process.env.ENV !== 'dev') {
        if (
          isInstore &&
          JSON.parse(localStorage.getItem('selectedStore')).stripeConnectId &&
          JSON.parse(localStorage.getItem('selectedStore')).stripeConnectId !==
            null
        ) {
          setStripePromise(
            loadStripe(stripeKey, {
              stripeAccount: JSON.parse(localStorage.getItem('selectedStore'))
                .stripeConnectId,
            })
          )
        } else {
          setStripePromise(
            loadStripe(stripeKey, {
              stripeAccount: process.env.STRIPE_ACCOUNT_ID,
            })
          )
        }
      } else {
        setStripePromise(
          loadStripe(stripeKey, {
            stripeAccount: process.env.STRIPE_ACCOUNT_ID,
          })
        )
      }
    }
  }, [])
  return stripePromise
}
